import { render, staticRenderFns } from "./SidebarInfo.vue?vue&type=template&id=a0d301d2&"
import script from "./SidebarInfo.vue?vue&type=script&lang=ts&"
export * from "./SidebarInfo.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports